var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IdfTextIcon',{class:_vm.style,attrs:{"icon-left":_vm.icon}},[_vm._v(_vm._s(_vm.$t(_vm.text)))])
}
var staticRenderFns = []

export { render, staticRenderFns }